<mat-sidenav-container class="example-container">
  <mat-sidenav #sidenav mode="side" class="sidenav-padding">
    <br>
    Contracts Actions
    <br>
    <br>
    Downloads
    <br>
    <button mat-button color="primary" (click)="exportCSV()">CSV</button>
    <br>
    <button mat-button color="primary" (click)="exportExcel()">Download as Excel</button>
    <br>
    <mat-divider></mat-divider>
    <br>
    <br>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-grid-list cols="12" rowHeight="40px">
      <mat-grid-tile [colspan]="1" [rowspan]="2"></mat-grid-tile>
      <mat-grid-tile [colspan]="9" [rowspan]="2">
        <input
          type="text"
          class="filter-control"
          (input)="onSearchChange($event.target.value)"
          placeholder="Find...">
      </mat-grid-tile>
      <mat-grid-tile [colspan]="1" [rowspan]="2"></mat-grid-tile>
    </mat-grid-list>

    <ag-grid-angular
      style="width: 100%; height: 800px;"
      class="ag-theme-balham"
      [rowData]="archivedContractList"
      [columnDefs]="archivedContractCols"
      (gridReady)="onGridReady($event)"
      (cellClicked)="onCellClicked($event)">
    </ag-grid-angular>
  </mat-sidenav-content>
</mat-sidenav-container>
